import { useAppDispatch } from "../hooks/useAppDispatch";
import { useAppSelector } from "../hooks/useAppSelector";
import { useSearchParams } from "react-router-dom";
import {
  resetPreviousFid,
  resetSelectedCard,
  setCurrentOpenedCardPage,
  setSelectedCard,
} from "../services/reducers/filters";
import { CardType } from "../interfaces/card";

export const useCardNavigation = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const previousFid = useAppSelector((state) => state.filters.previousFid);
  const openedCityCard = useAppSelector((state) => state.cities.openedCity);
  const plotsData = useAppSelector((state) => state.filters.plots.data);
  const investmentData = useAppSelector(
    (state) => state.filters.investmentOpportunities.data,
  );
  const spacesData = useAppSelector(
    (state) => state.filters.spacesForRent.data,
  );

  const determineEntityTypeByFid = (
    fid: string,
  ): "InvestmentOpportunities" | "Plots" | "SpacesForRent" | null => {
    if (plotsData.some((item) => item.fid?.toString() === fid)) return "Plots";
    if (investmentData.some((item) => item.fid?.toString() === fid))
      return "InvestmentOpportunities";
    if (spacesData.some((item) => item.fid?.toString() === fid))
      return "SpacesForRent";
    return null;
  };

  const openPreviousCard = () => {
    if (previousFid) {
      const filterType = determineEntityTypeByFid(previousFid);
      if (filterType) {
        dispatch(
          setSelectedCard({
            filterType,
            card: previousFid,
            openedFromMap: false,
          }),
        );
        dispatch(resetPreviousFid());
      } else {
        searchParams.delete("fid");
        setSearchParams(searchParams, { replace: false });
      }
    } else {
      searchParams.delete("fid");
      setSearchParams(searchParams, { replace: false });
    }
  };

  const closeCurrentCard = (currentFid: string | null) => {
    const isSameAsPrevious =
      currentFid === null ||
      (currentFid && currentFid === previousFid) ||
      !previousFid;
    if (isSameAsPrevious) {
      dispatch(resetSelectedCard());
      dispatch(resetPreviousFid());
      searchParams.delete("fid");
      setSearchParams(searchParams, { replace: false });
    } else {
      openPreviousCard();
    }
    if (openedCityCard) {
      dispatch(setCurrentOpenedCardPage("cities"));
    }
  };

  return {
    openPreviousCard,
    closeCurrentCard,
  };
};

export const handleSelectCard = (
  dispatch: ReturnType<typeof useAppDispatch>,
  type: CardType,
  data: string,
  openedFromMap: boolean,
) => {
  if (!data) return;
  dispatch(setSelectedCard({ filterType: type, card: data, openedFromMap }));
  dispatch(setCurrentOpenedCardPage("filter"));
};
